import { useEffect } from "react";
import { useFilter, resetFilter, defaultFilter } from "@/hooks/useFilter";
import { validate, getCriticalResources } from "./validate.utils";
import type { useMachineProps } from "../types";

export function Validate(props: useMachineProps) {
  const filter = useFilter();


  useEffect(() => {
    if (!props.state.matches("validating") || !filter) return;

    //debugger; 
    const result = validate(filter);

    if (result.success)
    {
      const criticalKeys = getCriticalResources(filter);
      if (props.state.matches("validating")) {
        props.send({ type: "VALIDATE", criticalResources: new Set(criticalKeys) });
      }
    }
    else
    {
      if (props.state.matches("validating")) {
        filter.setFilter(defaultFilter) // resetting the filter
        props.send({ type: "RETRY" });
      }
    }

  }, [props, filter]);

  return null;
}

